import React from 'react';
import DrawerBody from 'components/ui/DrawerBody';
import DrawerHeader from 'components/ui/DrawerHeader';
import DrawerFooter from 'components/ui/DrawerFooter';
import FilterAndSelect from 'components/ui/FilterAndSelect';

import { getTranslatedString } from 'helpers/i18n';

export const FilterAndSelectDrawer = ({
  handleClose,
  options,
  selected,
  handleSelect,
  filterOptions,
  handleFilter,
  handleContinue,
  verbiage = {},
}) => {
  return (
    <React.Fragment>
      <DrawerHeader
        onClose={handleClose}
        title={
          verbiage.selectTitle || getTranslatedString('landlordPortal.multiselectAdvanced.select')
        }
        subHeader={verbiage.selectSubheader}
        closeVerbiage={verbiage.onClose || getTranslatedString('cancel')}
      />
      <DrawerBody>
        <FilterAndSelect
          filterOptions={filterOptions}
          options={options}
          selected={selected}
          handleSelect={handleSelect}
          handleFilter={handleFilter}
          verbiage={verbiage}
        />
      </DrawerBody>
      <DrawerFooter
        onPrimaryActionClick={handleContinue}
        primaryActionText={getTranslatedString('continue')}
      />
    </React.Fragment>
  );
};
